import React from "react";
import {
  Row,
  Col,
  Card,
  Alert,
  Button,
  Image,
  FormControl,
  InputGroup,
  Form,
  Modal,
  Spinner
} from "react-bootstrap";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import { FaEye, FaLastfmSquare } from "react-icons/fa"
import { NavLink } from "react-router-dom";
import Logo from "../../assets/img/hvezda.png";
import _props from "../../componets/_params";

class Register extends React.Component {
  state = {
    name: "",
    email: "",
    mobil: "",
    pass: "",
    confirmPass: "",
    alert: [],
    guid: "",
    pin: "",
    steps: 0,
    emailpin: "",
    mobilepin: "",
    checkModal: false,
    modaltype: "email",
    isCorrect: {
      email: false
    },
    loading: false
  };

  alertMsg(s,type) {
    this.setState({alert:[{
      type: "danger",
      text: s
    }]})
    return type;
  }

  isCorrect(e,type) {
    this.setState({alert:[],isCorrect: {...this.state.isCorrect,email:false}})
    let check = true;
    if (type == "email") {
      if (e.target.value.indexOf("@") == -1) check = this.alertMsg("Email musí obsahovat @",false);
      if (e.target.value.indexOf(' ') >= 0) check = this.alertMsg("Email nesmí obsahovat mezery",false);
      if (e.target.value.split(".").length < 2) check = this.alertMsg("Email musí obsahovat .",false);
      if (e.target.value.split("@")[e.target.value.split("@").length -1].indexOf(".") == -1) check = this.alertMsg("Email musí obsahovat . za zavináčem",false);
      if (e.target.value.split("@")[1].split(".")[0].length < 2) check = this.alertMsg("Email musí obsahovat sub-doménu.",false);
      if (e.target.value.split("@")[1].split(".")[1].length < 2) check = this.alertMsg("Email musí obsahovat doménu.",false);
    }

    if (check) {
      this.setState({isCorrect: {...this.state.isCorrect,email:check}})
    }
  }

  checkEmail = async () => {
    this.setState({ loading: true });
    const _res = await this.props._api({
      ...this.props,
      method: "post",
      data: {
        email: this.state.email ? this.state.email : this.state.mobil,
      },
      endpoint: "/api/Login/public/user/register/email",
      param: "",
    });

    this.setState({ loading: false });
    if (_res.status == 200) {
      this.setState({ checkModal: true, guid: JSON.parse(this.props._decrypt(_res.data)).guid });
      if (process.env.REACT_APP_ENV_TYPE == "DEV") console.log(JSON.parse(this.props._decrypt(_res.data)))
    } else {
      this.setState({
        alert: [
          {
            type: "danger",
            text: "Účet pro zadaný email již existuje",
          },
        ],
      });
    }
  }

  tryConfirm = async () => {
    const _res = await this.props._api({method: "server"});
    window.location.replace(_res + "/api/web/activate/" + this.state.guid + "/" + this.state.pin)
  };

  correct() {
    let correct = true;
    let email = this.state.email;
    if (this.state.name.length <= 3) {
      correct = false;
      this.setState({
        alert: [
          {
            type: "danger",
            text: "Uživatelské jemé musí mít více jak 3 znaky",
          },
        ],
      });
    }
    if (email.indexOf("@") < 0) {
      correct = false;
      this.setState({
        alert: [{ type: "danger", text: "Email neobsahuje znak '@'" }],
      });
    }
    if (email.indexOf(".") < 0) {
      correct = false;
      this.setState({
        alert: [{ type: "danger", text: "Email neobsahuje znak '.'" }],
      });
    }

    if (email.indexOf(" ") > -1) {
      correct = false;
      this.setState({
        alert: [{ type: "danger", text: "Email obsahuje mezery" }],
      });
    }
    if (email.length < 6) {
      correct = false;
      this.setState({
        alert: [{ type: "danger", text: "Email musí mít více jak 5 znaků" }],
      });
    }
    if (this.state.pass.length < 8) {
      correct = false;
      this.setState({
        alert: [
          { type: "danger", text: "Heslo musí obsahovat více jak 7 znaků" },
        ],
      });
    }
    if (this.state.pass != this.state.confirmPass) {
      correct = false;
      this.setState({
        alert: [
          {
            type: "danger",
            text: "Potvrzení hesla se neshoduje se zadaným heslem",
          },
        ],
      });
    }
    return correct;
  }

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: null,
      Title: null,
      SubTitle: null,
    });

    if (this.props.params.id == "validate") {
      this.setState({checkModal: true, guid: this.props.params.guid})
    }
    if (process.env.REACT_APP_ENV_TYPE == "DEV") console.log(this.props);
  }

  render() {
    return (
      <>
        <Modal
          show={this.state.checkModal}
          onHide={() => this.setState({ checkModal: false })}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header closeButton>
            {this.state.modaltype == "email" && (
              <span>Ověření emailové adresy</span>
            )}
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <Alert variant="info">
                  Děkujeme za registraci. Aktivační odkaz byl zaslán na Váš email. Přejděte do emailu a klikněte na nativační odkaz. Aktivační odkaz je platný pouze do dnešní půlnoci.
                </Alert>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
        <div className="c-register-center">
          <Card>
            <Card.Body>
              <Row className="mb-4">
                <Col xs={12}>
                  <span className="h5">
                    {this.props.ip.indexOf("192.168.") == -1 && (
                      <strong>Registrace</strong>
                    )}
                    {this.props.ip.indexOf("192.168.") > -1 && (
                      <strong>Interní služby</strong>
                    )}
                  </span>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Image
                    src={Logo}
                    className="c-login-logo c-login-squircle me-2"
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col xs={12}>
                  <span className="h5">
                    <strong>Britex</strong>
                  </span>
                </Col>
              </Row>
              {this.state.alert.length > 0 && (
                <Alert variant={this.state.alert[0].type}>
                  {this.state.alert[0].text}
                </Alert>
              )}
              {(this.props.ip.indexOf("192.168.") == -1 && this.props.ip.indexOf("0::1") == -1) && (
                <>
                  <Row className="mb-4">
                    <Col xs={12}>
                      <InputGroup>
                        <FormControl
                          type="email"
                          value={this.state.email}
                          onChange={(e) => {this.setState({ email: e.target.value }); this.isCorrect(e,"email");}}
                          onKeyDown={(e) => e.key == "Enter" ? this.checkEmail() : ""}
                        />
                        {(this.state.isCorrect.email && !this.state.checkModal) && (
                          <Button 
                            disabled={this.state.loading} 
                            variant="success" 
                            onClick={this.checkEmail}>
                              {this.state.loading && (
                                <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              )}
                              {!this.state.loading && (
                                <>Registrovat</>
                              )}
                              
                          </Button>
                        )}
                      </InputGroup>
                      <Form.Text>Zadejte váš email</Form.Text>
                    </Col>
                  </Row>
                </>
              )}

              {(this.props.ip.indexOf("192.168.") > -1 || this.props.ip.indexOf("0::1") > -1) && (
                <>
                  <Row className="mb-4">
                    <Col xs={12}>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() =>
                          window.location.replace(process.env.REACT_APP_OAUTH2)
                        }
                      >
                        <Image src={Logo} className="c-logo-transparent me-2" />
                        <strong className="me-2">OAuth2</strong>
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
}

export default _props(Register);
